import { useEffect, useState } from "react";
import {
  fetchPendingSwaps,
  fetchUnconfirmedPaymentTransactions,
  fetchUnconfirmedWithdrawTransactions,
} from "../components/constants";

function usePendingTransactions(currency) {
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let ignore = false;

    const fetchData = async () => {
      setIsLoading(true);
      setTransactions([]);

      try {
        const [pendingPayments, pendingWithdraws, pendingSwaps] =
          await Promise.allSettled([
            fetchUnconfirmedPaymentTransactions(10, currency),
            fetchUnconfirmedWithdrawTransactions(10, currency),
            fetchPendingSwaps(10, currency),
          ]);

        if (ignore) return;
        const result = [
          ...(pendingPayments.status === "fulfilled" ? pendingPayments.value.data : []),
          ...(pendingWithdraws.status === "fulfilled" ? pendingWithdraws.value.data : []),
          ...(pendingSwaps.status === "fulfilled" ? pendingSwaps.value.data : []),
        ];

        setTransactions(result.sort((a, b) => b.created - a.created));
        setIsLoading(false);
      } catch {
        if (ignore) return;
        setTransactions([]);
        setIsLoading(false);
      }
    };

    fetchData();
    return () => {
      ignore = true;
    };
  }, [currency]);

  return { transactions, isLoading };
}

export default usePendingTransactions;
